import { Text } from '../../../..'

import styles from './RoomCountRadio.module.scss'

export interface RoomCountRadioProps {
  name: string
  label: string
  value?: number
  isChecked: boolean
  onChange: () => void
}

export const RoomCountRadio = ({ name, value, label, onChange, isChecked }: RoomCountRadioProps) => {
  return (
    <div className={styles.radio}>
      <input
        name={name}
        type='radio'
        value={value}
        data-qa={name}
        checked={isChecked}
        onChange={onChange}
        id={`${name}${value}`}
      />
      <Text
        size='xs'
        element='label'
        weight='semibold'
        variantCount='900'
        variant='neutralCool'
        className={styles.label}
        htmlFor={`${name}${value}`}
      >
        {label}
      </Text>
    </div>
  )
}
